import { ChangeDetectionStrategy, Component, Inject } from '@angular/core'
import { AbstractControl, FormControl, ValidatorFn, Validators } from '@angular/forms'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { SetNameDialogData, SetNameDialogResult } from './set-name-dialog.model'

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-set-name-dialog',
  styleUrl: './set-name-dialog.component.scss',
  templateUrl: './set-name-dialog.component.html',
})
export class SetNameDialogComponent {
  name: FormControl
  description: FormControl
  title = ''
  actionName: string
  entityName: string
  otherNames: string[]
  showDescription: boolean

  constructor(
    public dialogRef: MatDialogRef<SetNameDialogComponent, SetNameDialogResult>,
    @Inject(MAT_DIALOG_DATA) public data: SetNameDialogData,
  ) {
    this.actionName = data.actionName || 'Add'
    this.entityName = data.entityName || ''
    this.showDescription = !!data.showDescription
    this.title = this.getTitle()
    this.name = new FormControl(data.currentName || '', [
      Validators.required,
      this.uniqueNameValidator(data.otherNames),
    ])
    this.description = new FormControl(data.currentDescription || '')
  }

  onSave() {
    if (this.name.invalid) {
      return
    }
    this.dialogRef.close({
      name: this.name.value,
      description: this.description.value,
    })
  }

  private getTitle(): string {
    const suffix = this.entityName ? ` ${this.entityName}` : ''
    return `${this.actionName}${suffix}`
  }

  private uniqueNameValidator(otherNames: string[] = []): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const value = ((control.value as string) || '').toLowerCase()
      const unique = otherNames.every((name) => name.toLowerCase() !== value)
      return unique ? null : { duplicateName: { value } }
    }
  }
}
